import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted, onBeforeMount} from 'vue'
import twoPointSlider from "@busy-human/vue-component-library/components/twoPointSlider.vue"
import checkbox from '../../components/checkmarkbox.vue'
import { Userspaces, Weekday } from '@busy-human/opt-library'
import VLoader from "@/components/loader.vue";
import { useUserspace } from '@/store/userspace'


type Emits = {
    (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'availability-overlay',
  emits: ["close"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {
  expose();



const loading = ref(false);
const userspace = useUserspace();

const timeAvailability = ref({
    start: "9:00 am",
    end: "5:00 pm"
})

const weekSelection = ref<{[day: string]: boolean}>({
    SUN: false,
    MON: false,
    TUE: false,
    WED: false,
    THU: false,
    FRI: false,
    SAT: false,
})

onBeforeMount(() => {
    let userAvailability = userspace.user.timesAvailable?.[0]
    if(userAvailability){
        if( userAvailability.days.includes(Weekday.SUN)) {
            weekSelection.value.SUN = true;
        }
        if( userAvailability.days.includes(Weekday.MON)) {
            weekSelection.value.MON = true;
        }
        if( userAvailability.days.includes(Weekday.TUE)) {
            weekSelection.value.TUE = true;
        }
        if( userAvailability.days.includes(Weekday.WED)) {
            weekSelection.value.WED = true;
        }
        if( userAvailability.days.includes(Weekday.THU)) {
            weekSelection.value.THU = true;
        }
        if( userAvailability.days.includes(Weekday.FRI)) {
            weekSelection.value.FRI = true;
        }
        if( userAvailability.days.includes(Weekday.SAT)) {
            weekSelection.value.SAT = true;
        }

        if( userAvailability.startTime){
            let startHour = Math.trunc(userAvailability.startTime)
            if(startHour > 12){
                startHour = startHour - 12
            }
            let startMin = ((userAvailability.startTime - Math.trunc(userAvailability.startTime)) * 60).toString()
            if(startMin.toString().length == 1){
                startMin = `0${startMin}`
            }
            timeAvailability.value.start = `${startHour}:${startMin} ${userAvailability.startTime > 12 ? 'pm' : 'am'}`
            // console.log("worked?", timeAvailability.value.start)
        }
        if( userAvailability.endTime){
            
            let endHour = Math.trunc(userAvailability.endTime)
            if(endHour > 12){
                endHour = endHour - 12
            }
            let endMin = ((userAvailability.endTime - Math.trunc(userAvailability.endTime)) * 60).toString()
            if(endMin.toString().length == 1){
                endMin = `0${endMin}`
            }
            timeAvailability.value.end = `${endHour}:${endMin} ${userAvailability.endTime > 12  ? 'pm' : 'am'}`
            // console.log("worked?", timeAvailability.value.end)
        }
    }
})


const timeToNum = (time:string)=>{
    const tmp = time.split(":")
    const tmp2 = tmp[1].split(" ")
    let amOrPm = tmp2[1]
    let hour = parseFloat(tmp[0])
    let minute = (parseFloat(tmp2[0]) / 60)
    if(amOrPm == 'am'){
        if(hour == 12){
            hour = 0;
        }
    }else if(amOrPm == "pm"){
        if(hour < 12){
            hour += 12
        }
    }

    let timeAsNumber = hour + minute
    return timeAsNumber
}

const confirmAvailability = () =>{
    let user = userspace.user;
    //@ts-ignore
    if(!user) return

    let availableDays:Weekday[] = []

    Object.keys(weekSelection.value).forEach((day)=>{
        //@ts-ignore
        if(weekSelection.value?.[day]){
            availableDays.push(Weekday[day as keyof typeof Weekday] )
        }
    })

    let availableTime = {
        startTime: timeToNum(timeAvailability.value.start),
        endTime: timeToNum(timeAvailability.value.end),
        days: availableDays
    }
    Userspaces.Collection.updateDoc(user.$id, {
        timesAvailable: [availableTime]
    })

    emit('close')
}


const __returned__ = { emit, loading, userspace, timeAvailability, weekSelection, timeToNum, confirmAvailability, ref, onMounted, onBeforeMount, twoPointSlider, checkbox, Userspaces, Weekday, VLoader, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})